<template>
    <div>
        <el-card style="margin-bottom: 25px;border: none;box-shadow: none;"
            :class="isShow ? 'show_card' : 'show_card header-border'">
            <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow">
                <span style="font-weight: bold;font-size: 14px;color: #636569">信息解释</span>
                <i class="el-icon-arrow-up" v-show="isShow"
                    style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开介绍">折叠</i>
                <i class="el-icon-arrow-down" v-show="!isShow"
                    style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠介绍">展开</i>
            </div>
            <el-descriptions v-show="isShow" style="margin-bottom: 0;font-size: 13px!important;" border :column="3"
                :labelStyle="{ width: '126px' }">
                <el-descriptions-item label="文件自动同步" :span="3">
                    该数据从share服务器获取，每3小时同步一次
                </el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-tabs v-model="activeName" @tab-click="changeTab">
            <el-tab-pane name="reportGeneration" label="结题报告生成"></el-tab-pane>
            <el-tab-pane name="NEW_CLOSING_REPORT" label="标准分析结题报告"></el-tab-pane>
            <el-tab-pane name="ADVANCED_ANALYSIS" label="高级分析报告"></el-tab-pane>
            <el-tab-pane name="CLOSING_REPORT" label="报账结题报告"></el-tab-pane>
            <el-tab-pane name="updateLog" label="更新日志"></el-tab-pane>
        </el-tabs>

        <el-tabs v-if="classList?.[activeName]?.length > 0" v-model="activeTab[activeName]" @tab-click="changeTab">
            <el-tab-pane v-for="(info, index) in classList[activeName]" :name="info" :label="info"
                :key="activeName + index"></el-tab-pane>
        </el-tabs>
        <el-tabs v-else-if="activeName === 'updateLog'" v-model="activeTab.updateLog" @tab-click="changeTab">
            <el-tab-pane name="NEW_CLOSING_REPORT" label="标准分析结题报告"></el-tab-pane>
            <!-- <el-tab-pane name="ADVANCED_ANALYSIS" label="高级分析报告"></el-tab-pane> -->
            <el-tab-pane name="CLOSING_REPORT" label="报账结题报告"></el-tab-pane>
        </el-tabs>

        <el-tabs
            v-if="activeName === 'ADVANCED_ANALYSIS' && Object.keys(classList?.[activeName] || {}).length > 0"
            v-model="activeTab[activeName]" @tab-click="changeTab">
            <el-tab-pane v-for="(items, key) in classList[activeName]" :name="key" :label="key"
                :key="activeName + key"></el-tab-pane>
        </el-tabs>

        <!-- 添加第三级标签页 -->
        <el-tabs
            v-if="activeName === 'ADVANCED_ANALYSIS' && activeTab[activeName] && classList[activeName][activeTab[activeName]] && classList[activeName][activeTab[activeName]].length > 0"
            v-model="activeTab[activeName + '_SECOND']" @tab-click="changeTab">
            <el-tab-pane v-for="(item, index) in classList[activeName][activeTab[activeName]]" :name="item"
                :label="item" :key="activeName + item + index"></el-tab-pane>
        </el-tabs>

        <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
            <div style="display: flex; align-items: center; flex-grow: 1;">
                <router-view></router-view>
                <el-button v-if="['reportGeneration'].includes(activeName)" size="small" type="primary"
                    icon="el-icon-plus" @click="toggleReportGeneration()">生成结题报告
                </el-button>
            </div>
        </div>

        <w-table ref="wMyTable" :columns="checkedCol" :table-data="reportList" v-if="activeName !== 'updateLog'"
            @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page" :isShowRowSelection="true"
            @rowSelection="rowSelection($event)" @pageChange="handlePagePagination">
            <template slot="analyzeExpenses" slot-scope="{text,record}">
                <span v-if="text">{{ text }}</span>
                <span v-else style="color: #5daf34">NA</span>
            </template>
            <template slot="otherCon">
                <table-col :cols="columns"
                    :columnType="activeName + activeTab[activeName] + 'tableCol'" :table-col="columns" @submit="getCheckedBox"></table-col>
            </template>
            <template slot="operation" slot-scope="{text,record}">
                <a v-if="activeName === 'pdf'" href="#" @click="handleDown(record['hexCode'])">
                    <i class="el-icon-download"></i>
                    <span v-if="record.reportName && record.reportName.length > 20">
                        <el-tooltip :content="'下载 ' + record.reportName">
                            <span>{{ record.reportName.substring(0, 20) }}...</span>
                        </el-tooltip>
                    </span>
                    <span v-else>
                        {{ record.reportName }}
                    </span>
                </a>
                <a v-else-if="['english', 'chinese'].includes(activeName)" href="#"
                    @click="handleDown(record['hexCode'])">
                    <i class="el-icon-download"></i>
                    <span v-if="record.contractFileName && record.contractFileName.length > 20">
                        <el-tooltip :content="'下载 ' + record.contractFileName">
                            <span>{{ record.contractFileName.substring(0, 20) }}...</span>
                        </el-tooltip>
                    </span>
                    <span v-else>
                        {{ record.contractFileName }}
                    </span>
                </a>
                <div v-else-if="['reportGeneration'].includes(activeName)">
                    <el-dropdown @command="handleCommand" style="margin-left: 10px" size="small"
                        v-if="Object.values(record['annex']).some(value => value !== null && value !== '')">
                        <el-button size="mini" type="primary" color="#ffffff">下载</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="record['annex']['REPORT_PDF']"
                                :command="{ annexType: 'REPORT_PDF', id: record.id }">PDF报告
                            </el-dropdown-item>
                            <el-dropdown-item v-if="record['annex']['SAMPLE']"
                                :command="{ annexType: 'SAMPLE', id: record.id }">样品文件
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-else>
                    <el-button icon="el-icon-download" type="primary" v-if="record['hexCode']" size="small"
                        @click="handleDown(record['hexCode'])">下载完整报告</el-button>
                    <el-button icon="el-icon-download" type="success" v-if="record['pdfHexCode']" size="small"
                        @click="handleDown(record['pdfHexCode'])">下载pdf结题报告</el-button>
                </div>
            </template>
            <template v-for="info in ['pdfReport','webReport','englishAnalysisMethod','chineseAnalysisMethod']" :slot="info" slot-scope="{text,record,index}">
                <div v-if="text && text !== '暂无'">
                    <div v-for="(fileName, idx) in text.split('/')" :key="idx" style="margin-bottom:4px;">
                        <a v-if="record['hexCode'] && !fileName.includes('标准分析：暂时')" href="#" @click.prevent="handleDown(record['hexCode'], fileName)">
                            <i class="el-icon-download"></i>
                            <span v-if="fileName.length > 20">
                                <el-tooltip :content="'下载 ' + fileName">
                                    <span>{{ fileName.substring(0, 20) }}...</span>
                                </el-tooltip>
                            </span>
                            <span v-else>{{ fileName }}</span>
                        </a>
                        <span v-else style="color: #5daf34">{{ fileName }}</span>
                    </div>
                </div>
                <span v-else style="color: #ff000e">{{ text || '暂无'}}</span>
            </template>
            <template slot="reportStatus" slot-scope="{text,record}">
                <span style="display: flex; align-items: center;">
                    <el-tag :type="getReportGenerationColor(text, 'tagType')"
                        :style="{ 'background-color': getReportGenerationColor(text, 'backgroundColor'), color: getReportGenerationColor(text, 'color') }">
                        {{ getReportGenerationColor(text, 'name') }} <i :class="[
                            getReportGenerationColor(text, 'icon'),
                            text === 'RUNNING' ? 'fa-spin-custom' : ''
                        ]"></i>
                    </el-tag>
                    <w-ellipsis-and-look v-if="text === 'RUN_FAILED'" style="margin-left:5px"
                        class="w-ellipsis-and-look" :text="record['failReason']" :column="{ title: '失败原因' }"
                        :onlyDetail="true" :isOpenHtml="false">
                    </w-ellipsis-and-look>
                </span>
            </template>
            <template slot="contractName" slot-scope="{text,record,index,column}">
                <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
            </template>
            <template slot="reportProjectType" slot-scope="{text,record,index}">
                <span v-if="text">{{ reportType[text]?.name || text }}</span>
                <span v-else style="color: #5daf34">NA</span>
            </template>
            <template slot="concreteType" slot-scope="{text,record,index}">
                <span v-if="text">{{ (reportType[record.reportProjectType]?.concreteType[text] || text) + '(' + text +
                    ')'
                    }}</span>
                <span v-else style="color: #5daf34">NA</span>
            </template>
            <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 10px 15px">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='运行中'>运行中</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已完成'>已完成</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='运行失败'>运行失败</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="filterReportProjectType"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 10px 15px">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='扩增子'>扩增子</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='细菌完成图'>细菌完成图</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='细菌扫描图'>细菌扫描图</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='宏基因组'>宏基因组</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='宏病毒组'>宏病毒组</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='裸测'>裸测</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='真核转录组'>真核转录组</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='原核转录组'>原核转录组</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='鱼类eDNA'>鱼类eDNA</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='非靶向代谢组'>非靶向代谢组</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='eDNA浮游'>eDNA浮游</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='宏转录组'>宏转录组</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='群体重测序'>群体重测序</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='个体重测序'>个体重测序</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='宏基因组binning'>宏基因组binning</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="watermarkFlag" slot-scope="{text,record,index}">
                <el-tag type="success" v-if="text">是</el-tag>
                <el-tag type="danger" v-else>否</el-tag>
            </template>
            <template slot="filterFlag" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 10px 15px">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='是'>是</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='否'>否</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
        </w-table>
        <el-timeline v-if="activeName === 'updateLog'">
            <el-timeline-item :color="item.size === 'large' ? '#409EFF' : '#e4e7ed'" :size="item.size"
                :timestamp="item.updateTime" placement="top" v-for="(item, index) in logData" :key="index">
                <el-card>
                    <h4 v-if="item['updateContent'] && item['updateContent'].length > 0">更新内容:</h4>
                    <ul>
                        <li class="logDetail" v-for="(itemInner, index) in item['updateContent']"><i
                                class="iconfont icon-dian"></i>{{
                            itemInner }}
                        </li>
                    </ul>
                </el-card>
            </el-timeline-item>
        </el-timeline>
        <!--    图片加载-->
        <picture-loading v-if="loading"></picture-loading>
        <create-report-generation v-if="showReportGeneration" :show-dialog="showReportGeneration"
            @submit="closeReportGeneration"></create-report-generation>
    </div>
</template>


<script>

import { reportGenerationPage } from "@/api/dilivery/report-generation";
import PictureLoading from "@/components/customerTable/PictureLoading";
import { methodTem } from "@/utils/data/tableCol/methodTem/methodTem";
import { getMethodLog, reportPage } from "@/api/dilivery/method";
import { reportGeneration } from "@/utils/data/tableCol/report-generation/report-generation";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getClassification } from "@/api/dilivery/salesData";
import { putBatchDownloads } from "@/api/dilivery/download";
import { getReportGenerationColor } from "@/color";
import CreateReportGeneration from "@/components/reportTem/CreateReportGeneration";
import { tableOperationMixin } from "@/mixins/tableOperation";
import TableCol from "@/components/customerTable/TableCol.vue";
import { reportData, advanced_analysis } from "@/utils/data/tableCol/reportData/reportData";
import { getReportDataPage } from "@/api/dilivery/reportData";

const baseURL = process.env.VUE_APP_BASE_API
const baseWs = process.env.VUE_APP_BASE_WS
export default {
    name: "ReportData",
    components: {
        PictureLoading, CreateReportGeneration, TableCol
    },
    mixins: [tableOperationMixin],
    data() {
        return {
            checkedCol: [],
            isShow: true,
            reportList: [],
            logData: [],
            // 分页参数
            page: {
                currentNum: 1,
                pageSize: 10,
                total: 0
            },
            sortConditionTag: [],
            searchConditionTag: [],
            selectable: [],
            loading: true,
            activeName: 'reportGeneration',
            activeTab:{
                NEW_CLOSING_REPORT:'',
                CLOSING_REPORT:'',
                ADVANCED_ANALYSIS: '',
                ADVANCED_ANALYSIS_SECOND: '',
                updateLog:'NEW_CLOSING_REPORT',
            },
            classList:{
                NEW_CLOSING_REPORT: [],
                CLOSING_REPORT: [],
                ADVANCED_ANALYSIS: {},
            },

            showReportGeneration: false,
            reportType: {
                NGS: {
                    name: '扩增子',
                    concreteType: {
                        '16s-ngs': '细菌二代扩增子',
                        '16s-tgs': '细菌三代扩增子',
                        'its-ngs': '真菌二代扩增子',
                        'its-tgs': '真菌三代扩增子',
                        'arch': '古菌扩增子'
                    }
                },
                BACTERIAL_COMPLETE_GENOME: {
                    name: '细菌完成图',
                    concreteType: {}
                },
                BACTERIAL_DRAFT_GENOME: {
                    name: '细菌扫描图',
                    concreteType: {}
                },
                RNA_SEQ: {
                    name: '真核转录组',
                    concreteType: {}
                },
                PROKARYOTIC_SEQ: {
                    name: '原核转录组',
                    concreteType: {}
                },
                META_GENOME: {
                    name: '宏基因组',
                    concreteType: {}
                },
                META_VIR_OME: {
                    name: '宏病毒组',
                    concreteType: {}
                },
                LC_MS: {
                    name: '非靶向代谢组',
                    concreteType: {}
                },
                FISH_EDNA: {
                    name: '鱼类eDNA',
                    concreteType: {}
                },
                EDNA_PLANKTON: {
                    name: 'eDNA浮游',
                    concreteType: {}
                },
                META_TRANSCRIPT: {
                    name: '宏转录组',
                    concreteType: {}
                },
                META_GENOME_BINNING: {
                    name: '宏基因组binning',
                    concreteType: {}
                },
                POPULATION_SEQUENCING: {
                    name: '群体重测序',
                    concreteType: {}
                },
                INDIVIDUAL_SEQUENCING: {
                    name:'个体重测序',
                    concreteType: {}
                },
                LC: {
                    name: '裸测',
                    concreteType: {
                        '宏基因组测序': '宏基因组测序',
                        '宏转录组测序': '宏转录组测序',
                        '宏病毒组测序': '宏病毒组测序',
                        '重测序': '重测序',
                        '真核转录组测序': '真核转录组测序',
                        '原核转录组测序': '原核转录组测序',
                        '全基因组甲基化测序': '全基因组甲基化测序'
                    }
                }
            }
        }
    },
    computed: {
        columns() {
            if (['CLOSING_REPORT'].includes(this.activeName)) {
                return JSON.parse(JSON.stringify(methodTem(this.searchConditionTag || {})))
            } else if (this.activeName === 'reportGeneration') {
                return JSON.parse(JSON.stringify(reportGeneration(this.searchConditionTag || {})))
            } else if (this.activeName === 'ADVANCED_ANALYSIS') {
                return JSON.parse(JSON.stringify(advanced_analysis(this.searchConditionTag || {})))
            } else {
                return JSON.parse(JSON.stringify(reportData(this.searchConditionTag || {})))
            }
        },
    },
    created() {
        this.getClassList()
        this.getData()
    },
    mounted() {
        this.connectWebSocket()
    },
    beforeDestroy() {
        this.disconnectWebSocket()
    },
    methods: {
        getCheckedBox(col, cols) {
            this.checkedCol = col.filter(item => cols.includes(item.title))
        },
        connectWebSocket() {
            const wsUrl = `${baseWs}/websocket`
            this.websocket = new WebSocket(wsUrl)

            this.websocket.onmessage = (event) => {
                if (event.data === 'refresh') {
                    this.loadReportData()
                }
            }

            // 心跳
            setInterval(() => {
                if (this.websocket?.readyState === WebSocket.OPEN) {
                    this.websocket.send('ping')
                }
            }, 30000)
        },

        loadReportData() {
            // 调用API重新加载数据
            this.getData()
        },

        disconnectWebSocket() {
            if (this.websocket) {
                this.websocket.close()
            }
        },

        getReportGenerationColor,
        //显示结题报告生成页面
        toggleReportGeneration() {
            this.showReportGeneration = true
        },
        //隐藏结题报告生成页面
        closeReportGeneration(type) {
            this.showReportGeneration = false
            this.getData(true)
        },
        changeShow() {
            this.isShow = !this.isShow
        },
        changeTab(tab, event) {
            if (this.activeName === 'ADVANCED_ANALYSIS') {
                if (!this.classList['ADVANCED_ANALYSIS'][this.activeTab['ADVANCED_ANALYSIS']].includes(this.activeTab['ADVANCED_ANALYSIS_SECOND'])) {
                    this.activeTab['ADVANCED_ANALYSIS_SECOND'] = this.classList['ADVANCED_ANALYSIS'][this.activeTab['ADVANCED_ANALYSIS']][0]
                }
            }
            if (this.activeName !== 'updateLog') {
                this.reportList = []
                this.getData(true)
            } else {
                this.logData = []
                this.getLogData()
            }
            this.$nextTick(() => {
                if (this.$refs.wMyTable) {
                    this.$refs.wMyTable.selectedRowKeys = []
                }
            })
            this.selectable = []
        },
        async batchDownload() {
            try {
                if (this.selectable.length <= 0) {
                    this.$messageUi.error('请勾选需要批量下载的文件')
                    return
                }
                const codes = this.selectable.map(item => item.hexCode)
                const now = new Date();
                const timeKey = now.toISOString().slice(0, 23);
                const response = await putBatchDownloads(codes, timeKey)
                if (response.code === 200) {
                    let url = `${baseURL}/batch-downloads/download-batch/${timeKey}`
                    const elink = document.createElement('a')
                    elink.href = url
                    document.body.appendChild(elink)
                    elink.click()
                    document.body.removeChild(elink);
                } else {
                    this.$messageUi.error('下载失败，请重试')
                }
            } catch (error) {
                console.log(error)
                this.$messageUi.error('下载失败，请重试')
            }
        },
        rowSelection(selectedRows) {
            this.selectable = JSON.parse(JSON.stringify(selectedRows))
        },
        getClassList() {
            for (let data of ['CLOSING_REPORT','NEW_CLOSING_REPORT','ADVANCED_ANALYSIS']) {
                let params = {
                    type: data
                }
                getClassification(params).then(res => {
                    if (data === 'ADVANCED_ANALYSIS') {
                        // 处理高级分析报告的三级结构
                        this.classList[data] = res.data;
                        // 获取第一级分类的第一个键
                        const firstLevelKeys = Object.keys(res.data);
                        if (firstLevelKeys.length > 0) {
                            // 设置第二级标签页的默认值
                            this.activeTab[data] = firstLevelKeys[0];
                            // 获取第二级分类的第一个值
                            const secondLevelItems = res.data[firstLevelKeys[0]];
                            if (secondLevelItems && secondLevelItems.length > 0) {
                                // 设置第三级标签页的默认值
                                this.activeTab[data + '_SECOND'] = secondLevelItems[0];
                            }
                        }
                    } else {
                        // 处理其他类型的二级结构
                        this.classList[data] = res.data.sort((a, b) => {
                            // 提取 a 的开头数字
                            const matchA = a.match(/^\d+/);
                            const numA = matchA ? parseInt(matchA[0], 10) : NaN;

                            // 提取 b 的开头数字
                            const matchB = b.match(/^\d+/);
                            const numB = matchB ? parseInt(matchB[0], 10) : NaN;

                            // 情况1：两者开头都有数字，按数字大小排序
                            if (!isNaN(numA) && !isNaN(numB)) {
                                return numA - numB;
                            }

                            // 情况2：其他情况（只有一个有数字，或都没数字），保持原顺序
                            return 0;
                        });
                        this.activeTab[data] = this.classList[data][0];
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        },
        //获取报告模板更新日志
        getLogData() {
            this.loading = true
            let params = {
                updateLogType: this.activeTab.updateLog,
            };
            getMethodLog(params).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.logData = res.data.map(item => {
                        return {
                            ...item,
                            size: 'large'
                        }
                    })
                }
            }).catch(err => { this.loading = false })
        },
        //获取报告模板数据列表
        getData(searchFlag) {
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
            };
            if (searchFlag) {
                params = {
                    'page.current': 1,
                    'page.size': 10,
                }
            }
            let activeName = this.activeName
            let sendData = {}
            if (activeName === 'ADVANCED_ANALYSIS') {
                // 高级分析报告使用三级结构
                sendData.classification = this.activeTab[activeName];
                sendData.subClassification = this.activeTab[activeName + '_SECOND'];
            } else {
                sendData.classification = this.activeTab[activeName];
            }
            if (this.activeName === 'CLOSING_REPORT') {
                sendData.informationType = 'CLOSING_REPORT'
            }
            
            if (this.searchConditionTag && this.searchConditionTag.length) {
                //遍历搜索条件的内容
                sendData = this.getSearch(sendData)
            }
            const methodMap = {
                CLOSING_REPORT: reportPage,
                reportGeneration: reportGenerationPage,
            };

            let apiMethod = methodMap[this.activeName] ?? getReportDataPage;
            apiMethod(params, sendData, activeName).then(res => {
                this.loading = false
                if (res.code === 200) {
                    if (this.activeName === 'reportGeneration') {
                        this.reportList = res.data.records
                    } else {
                        this.reportList = res.data.records.map((item, index) => {
                            return {
                                ...item,
                                id: (this.page.currentNum * this.page.pageSize) + index
                            }
                        })
                    }
                    // 分页赋值
                    this.page.currentNum = parseInt(res.data.current)
                    this.page.pageSize = parseInt(res.data.size)
                    this.page.total = parseInt(res.data.total)
                }
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        getSearch(sendData) {
            let data = { ...sendData }
            this.searchConditionTag.forEach(item => {
                if (this.activeName === 'reportGeneration') {
                    let value = item.value
                    if (item.key === 'reportStatus') {
                        if (item.value === '运行中') {
                            value = 'RUNNING'
                        } else if (item.value === '已完成') {
                            value = 'DONE'
                        } else if (item.value === '运行失败') {
                            value = 'RUN_FAILED'
                        }
                    } else if (item.key === 'reportProjectType') {
                        if (item.value === '扩增子') {
                            value = 'NGS'
                        } else if (item.value === '细菌完成图') {
                            value = 'BACTERIAL_COMPLETE_GENOME'
                        } else if (item.value === '细菌扫描图') {
                            value = 'BACTERIAL_DRAFT_GENOME'
                        } else if (item.value === '宏基因组') {
                            value = 'META_GENOME'
                        } else if (item.value === '宏病毒组') {
                            value = 'META_VIR_OME'
                        } else if (item.value === '裸测') {
                            value = 'LC'
                        } else if (item.value === '真核转录组') {
                            value = 'RNA_SEQ'
                        } else if (item.value === '原核转录组') {
                            value = 'PROKARYOTIC_SEQ'
                        } else if (item.value === '鱼类eDNA') {
                            value = 'FISH_EDNA'
                        } else if (item.value === '非靶向代谢组') {
                            value = 'LC_MS'
                        } else if (item.value === 'eDNA浮游') {
                            value = 'EDNA_PLANKTON'
                        } else if (item.value === '宏转录组') {
                            value = 'META_TRANSCRIPT'
                        } else if (item.value === '宏基因组binning') {
                            value = 'META_GENOME_BINNING'
                        } else if (item.value === '群体重测序') {
                            value = 'POPULATION_SEQUENCING'
                        } else if (item.value === '个体重测序') {
                            value = 'INDIVIDUAL_SEQUENCING'
                        }
                    } else if (item.key === 'watermarkFlag') {
                        if (item.value === '是') {
                            value = true
                        } else if (item.value === '否') {
                            value = false
                        }
                    }
                    if (['watermarkFlag'].includes(item.key)) {
                        data["query#" + item.key + '.EQ'] = value
                    } else {
                        data["query#" + item.key + '.LIKE'] = value
                    }
                } else {
                    let key = item.key
                    data[key] = item.value
                }
            })
            return data
        },
        //获取表格搜索条件
        getTableSearchSortCon(searchConditionTag, sortConditionTag) {
            this.searchConditionTag = searchConditionTag
            this.sortConditionTag = sortConditionTag
            this.getData(true)
        },
        //分页
        handlePagePagination(page) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData()
        },
        //下载模板
        async handleDown(hexCode, fileNameOrType) {
            try {
                let url = ''
                if (['CLOSING_REPORT'].includes(this.activeName)) {
                    // 保持原有行为
                    url = `${baseURL}/method-template/download/${hexCode}/${getDataInLocalStorage("token")}`
                } else if (['NEW_CLOSING_REPORT','ADVANCED_ANALYSIS'].includes(this.activeName)) {
                    // 当传入文件名时，按文件名逐条下载（对文件名进行编码）
                    const encodedName = encodeURIComponent(String(fileNameOrType || ''))
                    url = `${baseURL}/report-data/download/${hexCode}/${encodedName}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                } else {
                    // 其他情况保持原有行为
                    url = `${baseURL}/reports/template/download/${hexCode}/${getDataInLocalStorage("token")}`
                }
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
                this.$messageUi.error('下载附件失败')
            }
        },
        //下载结题报告生成的附件
        async handleCommand(command) {
            try {
                let url = `/contract_api/report-generation/attachment/${command.id}/${command.annexType}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
                this.$messageUi.error('下载附件失败')
            }
        },
    }
}
</script>

<style scoped>
h3 {
    margin-top: 0;
    font-size: 25px;
}

h4 {
    font-size: 16px;
}

.fa-spin,
.fa-spin-custom {
    animation: fa-spin 1s infinite linear !important;
}

@keyframes fa-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}

.el-card ul li {
    margin-top: 5px;
    font-weight: 550;
    font-size: 14px;
    word-wrap: break-word;
}
</style>
